export const BULK_ASSIGNMENT_TYPES = {
	PHONECALL: 'phonecall',
	TODO: 'todo'
} as const;

interface CallListContext {
	type: 'callList';
	id: number;
	name: string;
}

interface CampaignContext {
	type: 'campaign';
	id: number;
	name: string;
}

type BulkAssignmentContext = CallListContext | CampaignContext | null;

export interface BulkAssignmentPayload {
	bulkAssignment: true;
	activityType: (typeof BULK_ASSIGNMENT_TYPES)[keyof typeof BULK_ASSIGNMENT_TYPES];
	count: number;
	context: BulkAssignmentContext;
	fallback?: string;
}

export function parseBulkAssignmentMessage(message?: string): BulkAssignmentPayload | null {
	if (typeof message !== 'string' || !message.trim().length) {
		return null;
	}

	try {
		const parsed: unknown = JSON.parse(message);

		if (!parsed || typeof parsed !== 'object' || (parsed as any).bulkAssignment !== true) {
			return null;
		}

		const payload = parsed as Partial<BulkAssignmentPayload>;
		if (!payload.activityType || !payload.count) {
			return null;
		}

		return {
			bulkAssignment: true,
			activityType: payload.activityType,
			count: payload.count,
			context: payload.context ?? null,
			fallback: payload.fallback
		};
	} catch {
		return null;
	}
}
